import {genericDisplayTemplate, logoTemplate, noResultsTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default class ReportsBenchmarksIndex {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');
    const reportId = $('#addBenchmarkButton').attr('data-report-id');

    // Update report on click
    $('#updateReportSubmit').click(function() {
      $('#generate_pdf').val('true');
      $('#saveDashboardSections').click();
    })

    // Clear and blur typeahead
    $('.clear-blur-typeahead').click(function() {
      let t = $(this).closest('.input-group').find('.typeahead');
      t.typeahead('val', '');
      t.blur();
    })

    // Apply an existing model on typeahead select
    $('.benchmark-typeahead').bind('typeahead:beforeselect', function(ev, suggestion) {

      // Prevent default
      ev.preventDefault();

      // Set benchmark type
      let benchmarkableType;
      if (suggestion.record_type === 'lists') {
        benchmarkableType = 'List';
      } else if (suggestion.record_type === 'portfolios') {
        benchmarkableType = 'Portfolio';
      } else {
        benchmarkableType = 'Issuer';
      }

      // Build ajax call to add/remove selection from model filters
      let params = {};
      params['benchmarkable_id'] = suggestion.record_id;
      params['benchmarkable_type'] = benchmarkableType;
      params['benchmarkable_name'] = suggestion.name;
      let url = '/' + accountUrl + '/reports/' + reportId + '/benchmarks.json?' + $.param(params);

      // Create a filter for model
      $.ajax({
        type: 'POST',
        url: url,
        dataType: 'application/json',
        complete(result) { 

          // Reload table
          $('#report_benchmarks_table').DataTable().ajax.reload();

          // Clear typeahead
          $('.benchmark-typeahead').typeahead('val', '');

        },
      });

    });

  }

}